<template>
	<div class="offline-message-container">
		<transition name="fade-down">
			<div v-if="onlineStatus === onlineStates.recovered" class="priority-message message-online">
				<p>😄 It looks like you're online again!</p>
			</div>
			<div v-if="onlineStatus === onlineStates.offline" class="priority-message message-offline">
				<p>Oh no! 😔 You appear to be offline, you will not be able to place an order</p>
			</div>
			<div v-if="onlineStatus === onlineStates.failure" class="priority-message message-offline">
				<p>{{ displayMessage }}</p>
			</div>
		</transition>
	</div>
</template>

<script>
	import Vue from 'vue';
	import EventBus from '@EventBus';
	import { APP_STORE } from '@/stores/defs';
	import { mapGetters, mapActions } from 'vuex';
	import { OnlineStates } from '@Interface/OnlineStates';
	const message = `
		Oh no! It appears our services are down, please try again later or call in to place an order.
	`;
	export default {
		data() {
			return {
				onlineStates: OnlineStates,
				defaultFailureMessage: message,
				displayMessage: message,
			};
		},
		computed: {
			...mapGetters({
				onlineStatus: APP_STORE.GET_ONLINE_STATUS,
			}),
		},
		methods: {
			...mapActions({
				updateRefreshKey: APP_STORE.UPDATE_REFRESH_KEY,
				setOnlineStatus: APP_STORE.SET_ONLINE_STATUS,
			}),
			handleConnectivityFailure(failureMessage) {
				const message = failureMessage || this.defaultFailureMessage;
				const onlineStates = this.onlineStates;
				this.setOnlineStatus(onlineStates.failure);
				this.displayMessage = message;
				setTimeout(() => {
					this.setOnlineStatus(onlineStates.online);
				}, 6000);
			},
		},
		created() {
			window.addEventListener('online', () => {
				const onlineStates = this.onlineStates;
				const currentStatus = this.onlineStatus;
				const vue = this;
				if (currentStatus === onlineStates.offline) {
					vue.setOnlineStatus(onlineStates.recovered);
					vue.updateRefreshKey();
					setTimeout(() => {
						vue.setOnlineStatus(onlineStates.online);
					}, 3000);
				}
			});
			window.addEventListener('offline', () => {
				const onlineStates = this.onlineStates;
				this.setOnlineStatus(onlineStates.offline);
			});
			EventBus.$on('display-network-failure', this.handleConnectivityFailure);
		},
		destroyed() {
			EventBus.$off('display-network-failure');
		}
	}
</script>

<style lang="scss" scoped>
@import '@style-vars';
.offline-message-container {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	z-index: 9999;
	.priority-message {
		padding: 0.2em 1em;
		box-shadow: 0 2px 10px -4px rgba(27, 33, 58, 0.4);

		background-color: $landingPageBackground;
	
		font-weight: bold;;
		font-size: 1.2em;
		text-align: center;
		z-index: 9999;
		&.message-offline {
			color: $danger;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/common/BaseOffline.vue